
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"m29.875 11.125 2.25-2.25 7.071 7.071-2.25 2.25zm-4.5 4.5 2.25-2.25 7.071 7.071-2.25 2.25zm-4.5 4.5 2.25-2.25 7.071 7.071-2.25 2.25z","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M6 42h32L6 10z"}})]),_c('g',{staticClass:"i-stroke",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Rectangle 36",attrs:{"d":"M31 7H11v30h30V17"}}),_c('path',{staticClass:"i-Rectangle 37",attrs:{"d":"M15 20v13h13"}}),_c('path',{staticClass:"i-Line 33",attrs:{"d":"m32.199 15.773-17 17"}})])])
          )
        }
      }
    